import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Col } from "react-bootstrap";
import { BranchProxy } from "../../../main/graphql/types";
import { CompanyAccess } from "@me-team/host/main/graphql/types";
import { useRoleAccess } from "@me-team/host/src/utils/useRoleAccess";

type SidebarBranchesProps = {
    branches: BranchProxy[];
    handleChangeBranch: (id: number | string) => void;
    handleCloseNavbar?: () => void;
};

const SidebarBranchList: React.FC<SidebarBranchesProps> = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [showAllBranches, setShowAllBranches] = useState<boolean>(false);
    const { branchId } = useParams();
    const canViewBranch = useRoleAccess(CompanyAccess.BranchView);
    const canEditBranch = useRoleAccess(CompanyAccess.BranchEdit);
    const shouldShowBranchActionIcon = canViewBranch;
    const branchActionIcon = canEditBranch ? "bi bi-pencil text-primary" : "bi bi-eye text-primary";

    const activeBranches = props.branches?.filter(
        (branch) =>
            !branch.deleted &&
            branch?.employeesPaginated?.employees[0]?.userBranchRelations.some((item) => item.branch.id === branch.id)
    );

    const sortedBranches = activeBranches.sort((a, b) => {
        if (a.id === +branchId) return -1;
        if (b.id === +branchId) return 1;
        return 0;
    });

    const handleEditBranch = (updateId: number) => {
        if (!canViewBranch) return;
        navigate(`/edit-branch/${updateId}/${branchId}`);
        props.handleCloseNavbar?.();
    };

    return (
        <>
            {(showAllBranches ? sortedBranches : sortedBranches?.slice(0, 1))?.map((branch) => {
                return (
                    <div
                        key={branch.id}
                        className={`nav-item-menu rounded-1 px-3 d-flex justify-content-between mb-1 ${+branchId === branch.id ? "active" : ""}`}
                    >
                        <Col xs={10}>
                            <div
                                className="text-truncate me-2 w-100 cursor-pointer text-dark"
                                onClick={() => props.handleChangeBranch(branch.id)}
                            >
                                <i className="bi bi-scissors me-2"></i>
                                {branch.name}, {branch.city.name}
                            </div>
                        </Col>
                        {shouldShowBranchActionIcon && (
                            <button className="edit-button border-0 px-0" onClick={() => handleEditBranch(branch.id)}>
                                <i className={branchActionIcon}></i>
                            </button>
                        )}
                    </div>
                );
            })}
            {activeBranches.length > 1 && (
                <div className="rounded-1 text-center mb-2">
                    <Button
                        variant="light"
                        className="w-100 py-2 px-3 rounded-1 bg-white border-0 show-branch text-dark fw-normal fs-7"
                        onClick={() => setShowAllBranches(!showAllBranches)}
                    >
                        {showAllBranches ? t("Hide") : t("View all")}
                    </Button>
                </div>
            )}
        </>
    );
};

export default SidebarBranchList;
